<template>
  <div class="cert-service-container cert-large w-100" :class="separator?'cert-separator':''"  @click="()=>toggleActive()">
    <div class="d-flex flex-row">
      <m-icon :rounded="true" :icon="icon" class="my-auto" style="color: #266FD5"/>
      <div class="cert-title my-auto">{{ title }}</div>
    </div>
    <div class="cert-text">
      {{ content }}
    </div>
    <div class="cert-btn">
      <m-icon :icon="active?'expand_less':'expand_more'" style="opacity: 0.25"/>
    </div>
    <div class="cert-service-list bg-gray-100" :class="active?'cert-active':''">
      <div v-for="(item,index) in services" :key="index" class="cert-item">
        {{ `${index + 1}. ${item}` }}
      </div>
    </div>
    <div v-if="active" class="pb-4"/>
  </div>
</template>

<script>

import MIcon from "@/views/cert/components/MIcon.vue";

export default {
  name: "CertServiceContainer",
  components: {MIcon},
  props: {
    title: String,
    content: String,
    services: Array,
    icon: String,
    link: String,
    separator: Boolean,
    expanded: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
  },
  created() {
    this.active = this.expanded;
  }
}
</script>